import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'slnk-shared-not-found-page',
    templateUrl: './shared-not-found-page.component.html',
    styleUrls: ['./shared-not-found-page.component.scss'],
    standalone: false
})
export class SharedNotFoundPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
